module.exports = __webpack_public_path__ + "static/img/tabs06.13f32b62.png";